import "./styles/Events.module.css";
import { config } from "../../authConfig";
import { useState } from "react";
import { Box, Button, Grid2 } from "@mui/material";
import useFetchMsal from "../../Common/UI/hooks/useFetchMsal";
import { StepsEnum } from "./HorizontalLinearStepper";
import SNEvent from "./interfaces/SNEvent";
import { CommentDialog } from "./components/CommentDialog";
import { LoadingIndicator } from "../../Common/UI/components/Loading";
import useIsAdminAndViewOnly from "../../Common/UI/hooks/useIsAdminAndViewOnly";
import useIsFieldMarketer from "../../Common/UI/hooks/useIsFieldMarketer";

export default function WaitingForApprovalStep({ event, setEvent, handleStep }: { event: SNEvent; handleStep: (stepNum: number) => void; setEvent: React.Dispatch<React.SetStateAction<SNEvent>> }) {
  const [showComment, setShowComment] = useState(false);
  const [commentAction, setCommentAction] = useState<string>("");
  const execute = useFetchMsal();
  const { isViewOnly, isAdmin } = useIsAdminAndViewOnly();
  const { isFieldMarketerOrAdmin } = useIsFieldMarketer();
  const [isSending, setSending] = useState<boolean>(false);

  const handleCloseComments = () => {
    setShowComment(false);
  };
  const handleActionComment = (actionName: string) => {
    setShowComment(true);
    setCommentAction(actionName);
  };

  const handleDecline = async function (comment: string) {
    setEvent((prevEvent) => {
      event.comment = comment;
      return event;
    });
    try {
      setSending(true);
      const url = `${config.rootAPIUrl}${config.rootAPIList?.sendForRejection}`;
      const response = await execute("POST", url, event);
      setEvent(response);
      setSending(false);
      handleStep(StepsEnum.New);
    } catch (error) {
      console.error("Event rejection failed! ", error);
    } finally {
      setSending(false);
    }
  };

  const handleApprove = async function () {
    try {
      setSending(true);
      const url = `${config.rootAPIUrl}${config.rootAPIList?.approved}`;
      const response = await execute("POST", url, event);
      setEvent(response);
      setSending(false);
      handleStep(StepsEnum.Approved);
    } catch (error) {
      console.error("Event approval has failed! ", error);
    } finally {
      setSending(false);
    }
  };

  const handleArchive = async function (comment: string) {
    setEvent((prevEvent) => {
      event.comment = comment;
      return event;
    });

    try {
      setSending(true);
      const url = `${config.rootAPIUrl}${config.rootAPIList?.archive}`;
      const response = await execute("POST", url, event);
      setEvent(response);
      setSending(false);
      handleStep(StepsEnum.New);
    } catch (error) {
      console.error(error);
      throw new Error("Event archival failed!");
    }
  };

  return (
    <LoadingIndicator show={isSending}>
      <Grid2 container rowSpacing={2} justifyContent={"space-between"} alignItems={"center"} sx={{ paddingBottom: "20px" }}>
        <Grid2 size={4}>
          <Box>
            {" "}
            {isFieldMarketerOrAdmin && !isViewOnly ? (
              <>
                <Button
                  variant="contained"
                  onClick={handleApprove}
                  sx={{
                    backgroundColor: "primary.main",
                    "&:hover": {
                      backgroundColor: "primary.hover",
                    },
                    marginRight: "20px",
                  }}
                  disableElevation
                  disabled={isSending || !isFieldMarketerOrAdmin}
                >
                  {"Approve"}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setShowComment(true);
                    handleActionComment("decline");
                  }}
                  disabled={isSending || !isFieldMarketerOrAdmin}
                  sx={{ marginRight: "20px" }}
                >
                  {"Decline"}
                </Button>
                {
                  isAdmin && 
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setShowComment(true);
                        handleActionComment("archive");
                      }}
                      disabled={isSending || !isAdmin}
                    >
                      {"Archive"}
                    </Button>
                }
                
              </>
            ) : (
              <></>
            )}
          </Box>
        </Grid2>

        <Grid2 size={8}></Grid2>

        {showComment ? (
          commentAction === "decline" ? (
            <CommentDialog handleCloseComments={handleCloseComments} handleAction={handleDecline} />
          ) : commentAction === "archive" ? (
            <CommentDialog handleCloseComments={handleCloseComments} handleAction={handleArchive} />
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </Grid2>
    </LoadingIndicator>
  );
}
